import { emailsApi } from "../../api/config";
import Cookies from "js-cookie";

const basePath = "api/InventoryItem/Responsible";

export async function sendEmailAssignOrUnassign(emailData, context) {
  return await emailsApi
    .post(
      `${basePath}${
        context === "assign"
          ? "/AssignmentItem/SendEmail"
          : "/UnassignmentItem/SendEmail"
      }`,
      emailData,
      {
        headers: {
          "Content-type": "application/json",
          Authorization: "bearer " + (Cookies.get("auth-token") ?? ""),
        },
      }
    )
    .then(
      res => console.log("ok"),
      err => Promise.reject("error")
    );
}
